import { range } from '@abw/badger-utils'
import { useState, useEffect } from "react";
import { facetsDefault } from './facetsDefault';
import styles from './toolbar.module.css';

type RangeInputsPros = {
  buckets: number[],
  isPrice: boolean,
  maxValue: number,
  setMaxValue: any,
  setMinValue: any,
  field: string,
  minValue: number
}

const RangeInputs = ({ buckets, isPrice, minValue, maxValue, setMaxValue, setMinValue, field }: RangeInputsPros) => {
  return (
    <div className={styles.MinMaxFilter} id="MinMaxFilter">
        <select
          value={minValue}
          onChange={(e) => {setMinValue(e.target.value)}}
          aria-label={`${field} - Min Value`}
        >
          {
              range(0, maxValue - 1).map(
              n => (
                <option key={n} value={n}>{bucketValue(buckets, n, isPrice)}</option>
              )
            )
          }
           </select>
      <div className={styles.minMaxLine}>
       
      </div>
        <select
          value={maxValue}
          onChange={(e) => {setMaxValue(e.target.value)}}
          aria-label={`${field} - Max Value`}
        >

          {
             range(Number(minValue) + 1, buckets.length - 1).map(
              n => (
                <option key={n} value={n}>{bucketValue(buckets, n, isPrice)}</option>
              )
            )
          }

          </select>
    </div>
  )
}

const bucketValue = (buckets: number[], n: number, isPrice: boolean) => {
  if (n === 0) {
    return 'Min'
  }
  if (n === buckets.length - 1) {
    return 'Max.'
  }

  const v = buckets[n]
  return v >= 1_000_000
    ? `${isPrice ? '£' : ''}${v / 1_000_000}m`
    : v >= 1_000 ? `${isPrice ? '£' : ''}${v / 1_000}k` : `${isPrice ? '£' : ''}${v}`
}

type Props = {
  field: string, additionalFields: [], facetData: any, facetName: string, isPrice: boolean, setFilter: any, filters: filters[], removeFilter: any, addFilter: any
}

type filters = {
  field: string,
  values: object
}

const MinMaxFilter = ({ field, additionalFields, facetData, facetName, isPrice = true, setFilter, filters, removeFilter, addFilter }: Props) => {


  const currentFilter = filters.filter(function (e) { return e.field === field; });
  const currentValues = currentFilter && currentFilter.length > 0 ? currentFilter[0]?.values ? currentFilter[0].values[0] : null  : null;
  const defaultFacets = facetsDefault()[facetName].ranges;
  const [from, setFromValue] = useState(0);
  const [to, setToValue] = useState(defaultFacets.length - 1);
  const [onLoad, setOnLoad] = useState(true)
  useEffect(() => {
    if (filters.length === 0 && !onLoad) {
      setFromValue(0)
      setToValue(facetData.length - 1)
    }

  }, [filters])

  const buckets: number[] = [];
  Object.keys(facetData).forEach(key => {
    const value = facetData[key];
    const defaultValues = defaultFacets.find((element) => element.name === value.value)
    if (value.value !== 'Any') {
      buckets.push(defaultValues.from)
    }
    if (onLoad) {
      if (currentValues && currentValues.from && defaultValues.from === currentValues.from && from !== Number(key)) {
        setFromValue(Number(key))
      }

      if (currentValues && currentValues.to && defaultValues.to === currentValues.to && to !== Number(key)) {

        setToValue(Number(key) + 1)
      }
      if (Number(key) === (facetData.length - 1)) {
      
        setOnLoad(false)
      }
      if (Number(key) === (facetData.length - 1) && to === 0 && (currentValues && !currentValues.to || !currentValues)) {
        setToValue(facetData.length)
      }
    }


  })

  const setMaxValue = (value) => {
    processFilter(
      {
       ...(buckets[from] ? { min: buckets[from] } : {}),
       ...(buckets[value] ? { max: buckets[value] } : {}),
      }
    );
    setToValue(value);
  }

  const setMinValue = (value) => {
    processFilter(
      {
       ...(buckets[value] ? { min: buckets[value] } : {}),
       ...(buckets[to] ? { max: buckets[to] } : {}),
      }
    );

    setFromValue(value);
  }

  const processFilter = (props) => {
    const { min, max } = props;
    const defaultMax = buckets[buckets.length - 1];
    if (min || (max && max !== defaultMax)) {
      const filter = { name: field }
      if (min && min !== 0) filter.from = Number(min)
      if (max && max !== defaultMax) filter.to = Number(max)

      setFilter(field, filter, 'any')
      if (additionalFields) {
        additionalFields.forEach((fld) => {
          setFilter(fld, filter, 'any')
        })
      }
    } else {
      removeFilter(field)
      if (additionalFields) {
        additionalFields.forEach((fld) => {
          removeFilter(fld)
        })
      }
    }
  }
  return (
     <RangeInputs field={field}  buckets={buckets} isPrice={isPrice} minValue={from} maxValue={to} setMaxValue={setMaxValue} setMinValue={setMinValue} />

  )
}


export default MinMaxFilter;